/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareMusic: {
  name: 'square-music';
  data: string;
} = {
  name: 'square-music',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm0 2h16v16H4V4Zm12.949 3.684a1 1 0 0 1-.633 1.265L14 9.72V14a3 3 0 1 1-2-2.83V9.72a2 2 0 0 1 1.367-1.897l2.317-.772a1 1 0 0 1 1.265.633ZM11 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" fill="currentColor"/></svg>`,
};
